// extracted by mini-css-extract-plugin
export default {"form":"employeeForm__form___nMZd7","fields":"employeeForm__fields___ne7v5","select":"employeeForm__select___aXptO","actions":"employeeForm__actions___CoJnX"};